import { get } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';

import { Breadcrumbs, Typography } from '@mui/material';
import Schema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const BreadCrumbVerwendungsnachweis: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Breadcrumbs separator='›' aria-label='breadcrumb' sx={{ maxWidth: '81.875rem' }}>
				<Typography color='secondary'>Mein Bereich</Typography>
				<Typography color='secondary'>Förderungen</Typography>
				<Typography color='secondary'>Mittelabruf und Verwendungsnachweis</Typography>
				<Typography color='primary'>{get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '*')}</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadCrumbVerwendungsnachweis;
